<div class="toolbar">
    <div class="actions">
        <div class="group">
            <se-combobox
                [(ngModel)]="selectedArrangement"
                [items]="arrangements"
                [readOnly]="true"
                class="combobox"
                title="{{ 'ARRANGEMENT' | translate }}"
                valuePath="value"
                viewPath="key"
            ></se-combobox>

            <se-statebutton
                [(state)]="selectedFormat"
                [bindToState]="true"
                source="assets/images/cabrera.png"
                state1Title="{{ 'Standard' | translate }}"
                state2Title="{{ 'Cabrera' | translate }}"
                title="{{ 'FORMAT' | translate }}"
            ></se-statebutton>
            <se-statebutton
                [(state)]="selectedTimeAlignment"
                [bindToState]="true"
                source="assets/images/timeAlignment.png"
                state1Title="{{ 'SEQUENTIAL' | translate }}"
                state2Title="{{ 'SIMULTANEOUS' | translate }}"
                title="{{ 'TIME_ALIGNMENT' | translate }}"
            ></se-statebutton>
            <se-statebutton
                [(state)]="selectedPaperRate"
                [bindToState]="true"
                source="assets/images/paperRate.png"
                state1Title="{{ '25mm' | translate }}"
                state2Title="{{ '50mm' | translate }}"
                title="{{ 'PAPER_RATE' | translate }}"
            ></se-statebutton>
            <!-- <se-statebutton source="assets/images/paperRate.png" title="{{'CENTERING_BASELINE' | translate}}" state1Title="{{'ORIGINAL_BASELINE' | translate}}" state2Title="{{'FIT_BASELINE' | translate}}" [(isFirstStateSelected)]="!isFitBaseline"></se-statebutton> -->

            <se-sliderbutton
                [(ngModel)]="paperOpacity"
                max="1"
                min="0"
                step="0.1"
                title="{{ 'PAPER_OPACITY' | translate }}"
            ></se-sliderbutton>
            <se-sliderbutton
                [(ngModel)]="traceSpacing"
                max="2"
                min="0"
                step="0.005"
                title="{{ 'TRACE_SPACING' | translate }}"
            ></se-sliderbutton>
            <se-sliderbutton
                [(ngModel)]="studySpacing"
                [hidden]="!enableStudiesSpacing"
                max="2"
                min="-1"
                step="0.005"
                title="{{ 'STUDIES_SPACING' | translate }}"
            ></se-sliderbutton>

            <div class="break"></div>
        </div>

        <div class="group">
            <se-statebutton
                [(state)]="caliperMode"
                [bindToState]="true"
                source="assets/images/caliper.png"
                state1Title="{{ 'SINGLE_CALIPER' | translate }}"
                state2Title="{{ 'MULTI_CALIPER' | translate }}"
                title="{{ 'CALIPER' | translate }}"
            ></se-statebutton>
            <se-togglebutton
                [(ngModel)]="fiducialPointsVisible"
                source="assets/images/markers.png"
                title="{{ 'FIDUCIAL_POINTS' | translate }}"
                tooltip="{{ 'FIDUCIAL_POINTS' | translate }}"
            ></se-togglebutton>

            <div class="break"></div>
        </div>

        <div class="group">
            <se-imagebutton
                (click)="onFit()"
                [source]="'assets/images/fit.png'"
                title="{{ 'FIT' | translate }}"
                tooltip="{{ 'FIT' | translate }}"
            ></se-imagebutton>

            <se-sliderbutton [(ngModel)]="zoomFactor" max="10" min="1" step="0.09" title="Zoom"></se-sliderbutton>

            <div *ngIf="detailsVisible || customCommandState.visible" class="break"></div>
        </div>

        <div class="group">
            <se-togglebutton
                *ngIf="detailsVisible"
                [(ngModel)]="summaryVisible"
                [source]="mediaService.is16_9 ? 'assets/images/summary16_9.png' : 'assets/images/summarydefault.png'"
                title="{{ 'Summary' | translate }}"
                tooltip="{{ 'Summary' | translate }}"
            >
            </se-togglebutton>
            <se-imagebutton
                (click)="onCustomCommand()"
                [hidden]="!customCommandState.visible"
                [source]="customCommandState.source"
                [title]="customCommandState.text"
                [tooltip]="customCommandState.text"
            >
            </se-imagebutton>
        </div>
    </div>
</div>
